module.exports = __webpack_public_path__ + "static/media/group.5e9fa045.svg";